export default window.React;
export const useState = window.React.useState;
export const useEffect = window.React.useEffect;
export const useRef = window.React.useRef;
export const useMemo = window.React.useMemo;
export const useCallback = window.React.useCallback;
export const useReducer = window.React.useReducer;
export const Fragment = window.React.Fragment;
